var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-tabs',{model:{value:(_setup.activeName),callback:function ($$v) {_setup.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"从灵感创作","name":"1"}},[_c(_setup.CreateFromInspiration)],1),_c('el-tab-pane',{attrs:{"label":"优化现有脚本","name":"2"}},[_c(_setup.OptimizeScript)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }